<template>
  <div ref="root" class="sp-card-actions" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { hasSlotContentDeep } from "../../utils/slots";

const root = ref(null);

const hasActionsSlot = computed(() => hasSlotContentDeep(root.value));

const classModifiers = computed(() => ({
  "--has-actions-slot": hasActionsSlot.value,
}));
</script>

<style>
:host {
  display: block;
}
</style>

<style lang="scss" scoped>
.sp-card-actions {
  &.--has-actions-slot {
    display: flex;
    padding-inline: var(--sp-card-actions-padding-inline, var(--sp-comp-card-padding-inline, 1rem));
    padding-block: var(--sp-card-actions-padding-block, var(--sp-comp-card-padding-block, 0.5rem));
  }
}
</style>
